
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pac4k_15bup_3",
  "variant-gen-ai": "awsui_variant-gen-ai_pac4k_15bup_47",
  "variant-gen-ai-masked": "awsui_variant-gen-ai-masked_pac4k_15bup_48",
  "searchbar": "awsui_searchbar_pac4k_15bup_1",
  "searchbar-rtl": "awsui_searchbar-rtl_pac4k_15bup_1"
};
  